import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
export class TraitRegistryMediaFile extends TraitRegistryCategory {
    label = 'Alle Mediendateien';
    constructor(parent) {
        super(parent);
        super.init();
    }
    /*
      readonly mediumLabel = () =>
          new TraitTypeSelect({
              parent: this,
              label: 'MediumLabel',
              select: () => mediaLabeler.selectItems
          });
  */
    requiredMediumLabel = () => 
    // legacy
    new TraitTypeSelect();
}
